export const formattedSeconds = sec => Math.floor(sec / 60) + ':' + ('0' + sec % 60).slice(-2)
export const toSeconds = string => string.split(':').reduce((total, current) => total * 60 + parseInt(current), 0)



// WEBPACK FOOTER //
// ./util/time.js